var ReactRedux = require('react-redux');

var authActions = require('../../actions/authActions');
var orderActions = require('../../actions/orderActions');

var settingActions = require('../../actions/settingActions');

var HomePresentational = require('../../components/Client/Home.jsx');

var mapStateToProps = function(state) {
	return state;
};

var mapDispatchToProps = function(dispatch) {
	return {
		forgot: function(data) {
			dispatch(authActions.forgot(data));
		},

		signIn: function(data) {
			dispatch(authActions.signIn(data));
		},

		signUp: function(data) {
			dispatch(authActions.signUp(data));
		},

		loading: function(timeout) {
			dispatch(authActions.fetch(timeout));
		},

		load: function() {
			dispatch(settingActions.loadSettings());
		},

		unload: function() {
			dispatch(settingActions.unsubscribe());
		},

		createOrder: function(data) {
			dispatch(orderActions.createOrder(data));
		},

		createOrderRequest: function(data) {
			dispatch(orderActions.createOrderRequest(data));
		}
	};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(HomePresentational);


// WEBPACK FOOTER //
// ./src/containers/Client/Home.js